<template>
  <div>
    <v-container
      fluid
      fill-height
    >
      <v-layout
        align-center
        justify-center
        class="layout-terms"
      >
        <v-flex
          xs12
          sm8
          md10
        >
          <!-- Use term-->
          <v-card
            v-if="!alreadyAccepted"
            class="elevation-12"
          >
            <!-- Title use terms -->
            <v-card-title>
              <v-layout
                justify-center
                class="mt-4"
              >
                <h3
                  class="text-uppercase"
                >
                  {{ system.system }}
                </h3>
              </v-layout>
            </v-card-title>
            <v-card-subtitle>
              <v-layout
                justify-center
                class="mt-3"
              >
                <h3
                  class="text-uppercase"
                >
                  TERMOS DE USO
                </h3>
              </v-layout>
            </v-card-subtitle>
            <!-- Use term body -->
            <v-card-text>
              <v-card-text
                class="pt-5"
              >
                <v-row
                  v-if="loading"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
                <div
                  v-else
                >
                  <td
                    v-html-safe="system.content"
                    class="term-text text-justify"
                  />
                  <v-checkbox
                    v-model="terms"
                    :label="checkboxText"
                    class="mt-2"
                  >
                  </v-checkbox>
                </div>
              </v-card-text>
            </v-card-text>
            <!-- Actions buttons -->
            <v-card-actions
              class="justify-space-between px-10"
            >
              <v-dialog
                transition="dialog-top-transition"
                max-width="600px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Não aceito
                  </v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      color="secondary"
                      dark
                    >
                      Serviço de Atendimento ao Cliente
                    </v-toolbar>
                    <v-card-text>
                      <div class="text-h5 pa-12 text-justify">
                        Gostaríamos de entender o motivo do porque você não está de acordo
                        com os pontos explicitados pelo termo, por favor, entre em contato
                        através do nosso SAC
                        <a
                          href="https://servicos.decea.mil.br/sac/?a=atd&c=380"
                          target="_blank"
                        >https://servicos.decea.mil.br/</a>
                      </div>
                    </v-card-text>
                    <v-card-actions class="justify-space-between">
                      <v-row
                        align="center"
                        justify="space-around"
                      >
                        <v-btn
                          color="primary"
                          class="mb-3"
                          @click="dialog.value = false"
                        >
                          Voltar para o termo
                        </v-btn>
                        <v-btn
                          color="secondary"
                          class="mb-3"
                          @click="redirectToOrigemApplication"
                        >
                          Retornar para
                          <br>
                          a aplicação de origem
                        </v-btn>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
              <v-btn
                color="primary white--text"
                :disabled="isDisabled"
                target="_blank"
                @click="submit"
              >
                Ciente
              </v-btn>
            </v-card-actions>
          </v-card>
          <!-- Already accepted -->
          <v-card
            v-else
            class="elevation-12"
          >
            <!-- Tittle already accepted -->
            <v-card-title>
              <v-layout
                justify-center
                class="mt-4"
              >
                <h2
                  class="text-uppercase"
                >
                  Termos de uso: {{ system.system }}
                </h2>
              </v-layout>
            </v-card-title>
            <!-- body already accepted-->
            <v-card-text>
              <v-alert
                class="text-center text-justify"
                border="right"
                colored-border
                type="warning"
                elevation="2"
              >
                <h4>
                  Você já assinou o último termo de uso deste sistema
                </h4>
              </v-alert>
            </v-card-text>
            <v-card-actions
              class="justify-center px-10"
            >
              <v-btn
                v-if="system.fromUrl"
                color="warning white--text"
                elevation="2"
                :href="system.fromUrl"
                class="mb-4"
              >
                Voltar sistema original
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-footer
        dark
        absolute
      >
        <v-card
          class="flex"
          flat
          tile
        >
          <v-row
            align="stretch"
            class="mb-6"
          >
            <v-col
              md="2"

              offset-md="4"
            >
              <v-card
                elevation="0"
                class="pa-2 justify-center"
                tile
                align="center"
              >
                <a
                  href="https://www.decea.mil.br/"
                  target="_blank"
                >
                  <v-img
                    :aspect-ratio="0.831"
                    width="50px"
                    src="https://www.decea.mil.br/static/assets/images/dom-decea.png"
                  ></v-img>
                </a>
              </v-card>
            </v-col>
            <v-col

              md="2"
              offset-sm3="4"
            >
              <v-card
                elevation="0"
                class="pa-2 justify-center"
                tile
                align="center"
              >
                <a
                  href="https://www.fab.mil.br/index.php"
                  target="_blank"
                >
                  <v-img
                    :aspect-ratio="1.423"
                    width="90px"
                    src="https://www.fab.mil.br/images/sistema/geral/gladio_80px.png"
                  ></v-img>
                </a>
              </v-card>
            </v-col>
          </v-row>
          <v-row
            class="mb-6"
          >
            <v-col
              md="6"
              offset-md="3"
            >
              <v-card
                elevation="0"
                class="text-center"
                tile
              >
                Desenvolvido por ATD
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-footer>
    </v-container>
  </div>
</template>

<script>
import jsonWebToken from 'jsonwebtoken'
import getTermsData from '@/api/terms/getTermsData'
import acceptTerms from '@/api/terms/acceptTerms'

export default {
  name: 'TermView',
  data() {
    return {
      platformName: '',
      checkboxText: 'Declaro que li e concordo com os termos e condições de uso',
      terms: '',
      termStep: true,
      encryptMessage: '',
      system: {
        system: '',
        content: '',
        toUrl: '',
        fromUrl: '',
        crypted_ticket: '',
        token: '',
      },
      loading: false,
      alreadyAccepted: false,
      requiredItens: [],
      notRequiredItens: [],
    }
  },
  computed: {
    isDisabled() {
      return !this.terms
    },
  },
  created() {
    this.system.toUrl = this.$route.query.to_url
    this.system.fromUrl = this.$route.query.from_url
    this.system.crypted_ticket = this.$route.query.crypted_ticket

    this.loading = true

    jsonWebToken.sign({
      exp: Math.floor(Date.now() / 1000) + (60 * 60),
    }, process.env.VUE_APP_JWT_SECRET, {
      header: {
        kid: process.env.VUE_APP_JWT_KEY,
      },
    }, (err, token) => {
      this.system.token = token
      getTermsData(this.system.crypted_ticket, this.system.token)
        .then(data => {
          this.system.content = data.data.content
          this.system.system = data.data.system
          this.loading = false
        })
        .catch(error => {
          this.redirectToErroPage(error.request.status, JSON.parse(error.request.response).error)
        })
    })
  },
  methods: {
    toggleTerm() {
      this.termStep = this.termStep === 1 ? this.termStep - 1 : this.termStep + 1
    },
    submit() {
      acceptTerms(this.system.crypted_ticket, this.system.token)
        .then(() => {
          this.$router.push(`/redirect?url=${this.system.toUrl}`)
        })
        .catch(error => {
          this.redirectToErroPage(error.request.status, JSON.parse(error.request.response).error)
        })
    },
    redirectToOrigemApplication() {
      this.$router.push(`/redirect?url=${this.system.fromUrl}`)
    },
    redirectToErroPage(httpError, errorMessage) {
      this.$router.push({ name: 'error', query: { http_error: httpError, error_message: errorMessage, from_url: this.system.fromUrl } })
    },
  },
}
</script>

<style>
.title-accept-terms {
  font-size: 1em;
}
.fix-text {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: left;
  align-items: baseline;
}
.title-number {
  margin-right: 10px;
}
.fix-text {
  color: rgba(0, 0, 0, 1);
  font-weight: 500;
}
.term-text {
  color: rgba(0, 0, 0, 0.8);
}
.layout-terms{
  margin-bottom: 200px;
}
</style>
